import * as React from "react";
import {Component } from "react";
import "./navigation.scss";

import {NavigationConfiguration, NavigationItemConfiguration} from "../../../config/navigation-configuration";
import {UiState} from "../../../core/ui-state";
import {AppState} from "../app-mobx";
import {AppConfiguration} from "../../../core/config/app-configuration";
import SVG from "react-inlinesvg";
import rightArrow from "../../../assets/images/layout/right-arrow.svg";


export interface NavigationProps {
    config: NavigationConfiguration;
    handleNavigation: (route: string) => void;
    appConfig: AppConfiguration;
    appStore: AppState;
    uiStore: UiState;
}

export class Navigation extends Component<NavigationProps, any> {
    uiStore: UiState;
    constructor(props: NavigationProps) {
        super(props);
        this.uiStore = this.props.uiStore;
        this.state = {
            search: null
        };
    }
    setSidebarVisible(sidebarVisible: boolean): void {
        this.uiStore.setSidebarVisible(sidebarVisible);
    }
    handleLocalUrl(event: React.MouseEvent): void {
        event.preventDefault();
        this.props.handleNavigation((event.target as HTMLAnchorElement).pathname);
    }
    render(): React.ReactElement | null {
        const {config, appConfig} = this.props;
        const {subtopicId} = this.props.appStore;
        const naviItems: React.ReactElement[] = [];
        // const topicId = (topic) ? topic.id : "";
        let items: NavigationItemConfiguration[] = config.items;
        let backLink: React.ReactElement | null = null;
        const objektwesenParent = config.items.find((item) => item.id === "objektwesen");
        if (subtopicId && objektwesenParent
            && objektwesenParent.sub
            && objektwesenParent.sub.items.findIndex((item) => item.id === subtopicId) > -1) {
            // unternavigation von Objektwesen
            if (objektwesenParent && objektwesenParent.sub) {
                items = objektwesenParent.sub.items;
                if (objektwesenParent.href) {
                    let parentHref = objektwesenParent.href;
                    // prepend basename if local url
                    if (/^\/(\w|$)/.test(objektwesenParent.href)) {
                        parentHref = appConfig.basename + objektwesenParent.href;
                        parentHref = parentHref.replace("//", "/");
                        backLink = (<a href={parentHref} className={"navigation__back-link"}
                            onClick={(event: React.MouseEvent) => this.handleLocalUrl(event)}>
                            <span className={"sprite sprite--right-arrow"}><SVG src={rightArrow} /></span>
                            {objektwesenParent.title}</a>);
                    } else {
                        backLink = (<a href={parentHref} className={"navigation__back-link"}>
                            <span className={"sprite sprite--right-arrow"}><SVG src={rightArrow} /></span>
                            {objektwesenParent.title}</a>);
                    }
                }
            }
        }
        items.forEach((element, index) => {
            let innerElement: React.ReactElement;
            let addClass = "";
            if (element.id === subtopicId || (!subtopicId && element.id === "objektwesen")) {
                addClass = " current";
            }
            if (element.href) {
                let href = element.href;
                // prepend basename if local url
                if (/^\/(\w|$)/.test(element.href)) {
                    href = appConfig.basename + element.href;
                    href = href.replace("//", "/");
                    innerElement = (
                        <a href={href} target={element.target} onClick={(event: React.MouseEvent<HTMLAnchorElement>) =>
                            this.handleLocalUrl(event)}>{element.title}</a>
                    );
                } else {
                    innerElement = (
                        <a href={href} target={element.target}>{element.title}</a>
                    );
                }
            } else {
                // Einträge ohne Link welche nicht aktive sind überspringen
                if (element.id !== subtopicId) {
                    return;
                }
                innerElement = (
                    <span>{element.title}</span>
                );
            }
            naviItems.push(<li className={"navigation__list-item" + addClass} key={"navigation-" + index}>
                {innerElement}
            </li>);
        });
        return(
            <nav id="mainNav" className="layout__navigation">
                <div className="navigation home">
                    {backLink}
                    <ul className="navigation__list">
                        {naviItems}
                    </ul>
                </div>
            </nav>
        );
    }
}
